import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function ForWhomSection() {
  const forYou = ['Profesionales que llegan a casa agotados y sin energía creativa.', 'Parejas que pierden tiempo discutiendo qué cenar cada noche.', 'Personas que quieren comer bien sin que la cocina sea su segundo trabajo.', 'Cualquiera que sufra de fatiga de decisión al final del día.'];
  const notForYou = ['Personas que buscan recetas de alta cocina o técnicas complejas.', 'Quienes disfrutan pasando horas improvisando en el fogón cada noche.', 'Gente que no está dispuesta a dedicar 20 min a preparar sus bases.'];
  return <section className="py-12 md:py-24 px-4 bg-warm-100" data-id="element-88">
      <div className="max-w-5xl mx-auto" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-14" data-id="element-90">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-warm-900 leading-tight" data-id="element-91">
            ¿Es esto{' '}
            <span className="italic text-sage-dark font-medium" data-id="element-92">para ti?</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-93">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-3xl p-6 md:p-8 border border-sage/15 shadow-sm" data-id="element-94">
            <h3 className="font-heading text-xl font-semibold text-sage-dark mb-6 flex items-center gap-2" data-id="element-95">
              <span className="w-2 h-2 rounded-full bg-sage" data-id="element-96" />
              Es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-97">
              {forYou.map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2 + i * 0.08
            }} className="flex items-start gap-3 text-warm-800" data-id="element-98">
                  <div className="mt-0.5 p-1 rounded-full bg-sage/15 text-sage-dark shrink-0" data-id="element-99">
                    <CheckIcon className="w-3.5 h-3.5" strokeWidth={3} data-id="element-100" />
                  </div>
                  <span className="leading-relaxed" data-id="element-101">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-warm-50 rounded-3xl p-6 md:p-8 border border-warm-200/60" data-id="element-102">
            <h3 className="font-heading text-xl font-semibold text-warm-800/70 mb-6 flex items-center gap-2" data-id="element-103">
              <span className="w-2 h-2 rounded-full bg-warm-800/40" data-id="element-104" />
              No es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-105">
              {notForYou.map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: 10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2 + i * 0.08
            }} className="flex items-start gap-3 text-warm-800/70" data-id="element-106">
                  <div className="mt-0.5 p-1 rounded-full bg-warm-200/60 text-warm-800/60 shrink-0" data-id="element-107">
                    <XIcon className="w-3.5 h-3.5" strokeWidth={3} data-id="element-108" />
                  </div>
                  <span className="leading-relaxed" data-id="element-109">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}